// extracted by mini-css-extract-plugin
module.exports = {"headerWrap":"styles_headerWrap__0gnUY","subheader":"styles_subheader__F2fYo","header":"styles_header__QX2dH"};